import * as React from 'react'
import * as cn from 'classnames'
import { PlayerContext } from '@shared/player/integration/playbackArea'
import { Button, Playback } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import { PlayArrow } from '@amzn/dvui/dist/Icons/PlayArrow'
import { StorefrontItemPlaybackAction, ItemPrerolls, safeBool } from '@utils'
import { fireDraperTrackingEvent } from '../../../../../../DVWebNodeDraperPlayer/utils/metrics'
import { ref } from '@amzn/dv-web-node-reftags'

interface IntermissionHeroPlayButtonProps {
    playbackAction: StorefrontItemPlaybackAction
    prerolls: ItemPrerolls
    stopDraperPlayer: () => void
}

const refTag = ref('atv_sf_ih_pb')

export const PlayButton = (props: IntermissionHeroPlayButtonProps) => 
    <PlayerContext.Consumer>
        {({ onPlay }) => {
            const deeplinkClass =
                  onPlay ||
                  (Boolean(props.playbackAction.signInUrl) ||
                    safeBool(props.playbackAction.disableJs))
                    ? ''
                    : 'js-deeplinkable'

            const onClick = (e: React.MouseEvent) => {
                fireDraperTrackingEvent(props.prerolls, 'acceptInvitation')

                props.stopDraperPlayer()
        
                if (onPlay && props.playbackAction.fallbackUrl && props.playbackAction.titleID) {
                  onPlay({
                    playbackUrl: props.playbackAction.fallbackUrl,
                    fallbackUrl: props.playbackAction.appFallbackUrl,
                    signInUrl: props.playbackAction.signInUrl,
                    contentConfig: {
                      asin: props.playbackAction.titleID,
                      videoType: props.playbackAction.videoMaterialType,
                      trailer: false,
                      position: props.playbackAction.resumeTime || 0,
                      ref: refTag
                    }
                  })
                  e.preventDefault()
                }
              }

            return (
                <Button
                    href={props.playbackAction.fallbackUrl}
                    onClick={onClick}
                    use={Playback}
                    icon={<PlayArrow />}
                    shape={'pill'}
                    className={cn(deeplinkClass, 'tst-intermission-play-button')}
                    data-asin={props.playbackAction.titleID}
                    data-ref-tag={refTag}
                    data-ref={refTag}
                    data-resume-time={
                      (props.playbackAction.resumeTime || '0')
                    }
                    data-video-type={props.playbackAction.videoMaterialType}
                    data-session-id={props.playbackAction.sessionID}
                    data-fallback-url={props.playbackAction.appFallbackUrl}          
                >
                    <Text tag='span' string={props.playbackAction.label} />
                </Button>
            )
        }}
    </PlayerContext.Consumer>